"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _classBuilder = _interopRequireDefault(require("../builders/class-builder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AnimatorChildClasses = /*#__PURE__*/function () {
  function AnimatorChildClasses(props) {
    this.props = void 0;
    this.classes = void 0;
    this.props = props;
    this.classes = [this.getFirstLayer(), this.getSecondLayer(), this.getThirdLayer()];
  }

  var _proto = AnimatorChildClasses.prototype;

  _proto.getFirstLayer = function getFirstLayer() {
    var _this$props$animatorP = this.props.animatorProps,
        debug = _this$props$animatorP.debug,
        sequence = _this$props$animatorP.sequence,
        delay = _this$props$animatorP.delay,
        childClassName = _this$props$animatorP.childClassName;
    var animatorChildClassName = this.props.animatorChildClassName;
    return new _classBuilder["default"]().withChildLayer(1).withDebug(debug).withClassName(childClassName).withClassName(animatorChildClassName).withSequence(sequence || delay).build();
  };

  _proto.getSecondLayer = function getSecondLayer() {
    var _this$props$animatorP2 = this.props.animatorProps,
        translate = _this$props$animatorP2.translate,
        opacity = _this$props$animatorP2.opacity,
        scale = _this$props$animatorP2.scale,
        timing = _this$props$animatorP2.timing,
        height = _this$props$animatorP2.height,
        width = _this$props$animatorP2.width;
    return new _classBuilder["default"]().withChildLayer(2).withOpacity(opacity).withScale(scale).withTranslateWrapper(translate).withHeight(height).withWidth(width).withTiming(timing).build();
  };

  _proto.getThirdLayer = function getThirdLayer() {
    var translate = this.props.animatorProps.translate;
    return new _classBuilder["default"]().withChildLayer(3).withTranslate(translate).build();
  };

  _proto.get = function get() {
    return this.classes;
  };

  return AnimatorChildClasses;
}();

var _default = AnimatorChildClasses;
exports["default"] = _default;